import LegalArticle from "../components/LegalArticle";
import PageHero from "../components/PageHero";
import { termsOfService } from "../lib/legal";

export default function TermsPage() {
  return (
    <>
      <PageHero
        eyebrow="Legal"
        title={termsOfService.title}
        intro="The terms that govern your use of Qost.ai."
      />
      <LegalArticle doc={termsOfService} />
    </>
  );
}
